import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { RichUtils } from 'draft-js'
import StyleControl from './style_control'

export const styles = {
  BOLD: {
    fontWeight: 'bold'
  },
  ITALIC: {
    fontStyle: 'italic'
  },
  UNDERLINE: {
    textDecoration: 'underline'
  }
}

export default class FontStyle extends Component {
  static propTypes = {
    editorState: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
  }

  styleHandlerFor = style => event => {
    event.preventDefault()
    const { editorState } = this.props
    this.props.onChange(RichUtils.toggleInlineStyle(editorState, style))
  }

  renderControlFor(style, content) {
    const { editorState } = this.props
    const currentStyle = editorState.getCurrentInlineStyle()
    return (
      <StyleControl
        active={currentStyle.has(style)}
        style={style}
        styling={styles[style]}
        handler={this.styleHandlerFor(style)}>
        {content}
      </StyleControl>
    )
  }

  render() {
    return (
      <div className="control-group">
        {this.renderControlFor('BOLD', 'B')}
        {this.renderControlFor('ITALIC', 'I')}
        {this.renderControlFor('UNDERLINE', 'U')}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/Form/RichText/controls/font_style.js